const account = {
  state: {
    time: ''
  },

  mutations: {
    SET_TIME: (state, value) => {
      window.localStorage.setItem('t', value);
    },
    GET_TIME: (state) => {
      state.time = window.localStorage.getItem('t');
    },
    REMOVE_TIME: (state) => {
      window.localStorage.removeItem('t');
    }
  },

  actions: {
    
  }
}

export default account



// WEBPACK FOOTER //
// ./src/store/modules/expireTime.js